var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDonate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.2423 16.1995C37.2421 17.4505 36.7474 18.6506 35.866 19.5384C33.8369 21.5841 31.8681 23.7172 29.7621 25.6881C29.5269 25.9023 29.2185 26.018 28.9005 26.0115C28.5825 26.0049 28.2792 25.8765 28.0531 25.6527L21.9866 19.5405C21.1048 18.6521 20.6099 17.4512 20.6099 16.1995C20.6099 14.9478 21.1048 13.7469 21.9866 12.8586C22.4266 12.4153 22.95 12.0635 23.5266 11.8234C24.1033 11.5833 24.7217 11.4597 25.3463 11.4597C25.9709 11.4597 26.5893 11.5833 27.1659 11.8234C27.7425 12.0635 28.2659 12.4153 28.7059 12.8586L28.9263 13.081L29.1467 12.8586C29.8072 12.1909 30.6514 11.7349 31.5719 11.5486C32.4924 11.3623 33.4475 11.4542 34.3156 11.8124C35.1837 12.1707 35.9256 12.7792 36.4468 13.5604C36.968 14.3417 37.2449 15.2604 37.2423 16.1995Z",
    stroke: "#1C5365",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4005 44.7233L49.3506 36.7732C49.5846 36.5394 49.7163 36.2224 49.7165 35.8917V24.9727C49.7165 24.1457 49.388 23.3525 48.8032 22.7676C48.2183 22.1828 47.4251 21.8542 46.598 21.8542C45.771 21.8542 44.9778 22.1828 44.3929 22.7676C43.8081 23.3525 43.4795 24.1457 43.4795 24.9727V34.3283",
    stroke: "#1C5365",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4004 36.4073L43.1842 34.6235C43.2779 34.5299 43.3522 34.4187 43.4029 34.2964C43.4535 34.174 43.4796 34.0428 43.4794 33.9104C43.4791 33.7234 43.4269 33.5402 43.3285 33.3813C43.2301 33.2223 43.0894 33.0938 42.9222 33.0102L42.0012 32.5507C41.221 32.1606 40.3378 32.0257 39.4766 32.1653C38.6155 32.3048 37.8201 32.7117 37.2029 33.3283L35.3422 35.189C34.5624 35.9686 34.1241 37.026 34.1239 38.1287V44.7233M16.4524 44.7233L8.50232 36.7732C8.26832 36.5394 8.1367 36.2224 8.13641 35.8917V24.9727C8.13641 24.1457 8.46497 23.3525 9.0498 22.7676C9.63463 22.1828 10.4278 21.8542 11.2549 21.8542C12.082 21.8542 12.8752 22.1828 13.46 22.7676C14.0449 23.3525 14.3734 24.1457 14.3734 24.9727V34.3283",
    stroke: "#1C5365",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4523 36.4073L14.6685 34.6236C14.5749 34.5299 14.5007 34.4187 14.45 34.2964C14.3993 34.174 14.3733 34.0429 14.3733 33.9105C14.3733 33.53 14.5895 33.1828 14.9305 33.0103L15.8515 32.5508C16.6318 32.1607 17.515 32.0258 18.3761 32.1654C19.2372 32.3049 20.0327 32.7118 20.6498 33.3283L22.5105 35.189C23.2904 35.9686 23.7286 37.0261 23.7288 38.1287V44.7233",
    stroke: "#1C5365",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonate);
export default __webpack_public_path__ + "static/media/donate.31fbb408412c3ef68a229ac526c15498.svg";
export { ForwardRef as ReactComponent };